import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import { IconButton, Drawer } from "@mui/material";
import "./index.scss";
import { clearOfflineData } from "../../utils/offline-services";
import SideMenu from "../side-menu";
import { MOBILE_MENU } from "../side-menu/config";

const Header = () => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);

  const logout = () => {
    clearOfflineData("user");
    navigate("/login");
  };
  return (
    <div className="header-container">
      <div>
        <IconButton onClick={() => setOpenMenu(true)}>
          <MenuIcon color="light" />
        </IconButton>
      </div>
      <div>
        <IconButton onClick={logout}>
          <LogoutIcon color="light" />
        </IconButton>
      </div>

      <Drawer open={openMenu} onClose={() => setOpenMenu(false)}>
        <SideMenu
          options={MOBILE_MENU}
          onMenuCLick={() => setOpenMenu(false)}
        />
      </Drawer>
    </div>
  );
};

export default Header;
